import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * Input de senha com botão "olho" para mostrar/ocultar.
 * Compatível com o resto: aceita `className` para a raiz.
 */
export function PasswordInput({ className = "", inputClassName = "", ...props }) {
  const [visible, setVisible] = useState(false);
  const finalClass =
    inputClassName ||
    "h-14 w-full rounded-md border-2 border-slate-300 px-4 pr-11 text-base outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-200";
  return (
    <div className={`relative ${className}`}>
      <input
        {...props}
        type={visible ? "text" : "password"}
        className={finalClass + " pr-11"}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? "Ocultar senha" : "Mostrar senha"}
        data-testid={props["data-testid"] ? `${props["data-testid"]}-toggle` : "password-toggle"}
        tabIndex={-1}
        className="absolute right-3 top-1/2 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-md text-slate-400 hover:bg-slate-100 hover:text-slate-700"
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}
